const GITHUB_APP_INSTALL_URLS: Record<"local" | "staging" | "production", string> = {
  local: "https://github.com/apps/jigsawml-localprocessor",
  staging: "https://github.com/apps/jigsawml-stagingprocessor",
  production: "https://github.com/apps/jigsawml",
};

export const getGitHubAppInstallUrl = (): string => {
  const currentHostname = window.location.hostname.toLowerCase();

  if (currentHostname === "localhost" || currentHostname === "127.0.0.1") {
    return GITHUB_APP_INSTALL_URLS.local;
  }

  if (currentHostname.includes("staging")) {
    return GITHUB_APP_INSTALL_URLS.staging;
  }

  return GITHUB_APP_INSTALL_URLS.production;
};
